import axios from 'axios'

var apiKey = "pk.eyJ1IjoidmljZHVib3NzIiwiYSI6ImNqczNpN3B4djI3eHM0M3RmY29qcTZ0c2cifQ.DiW4jJ5luny6EX3ajfjoKg"
const MapService = {
    apiKey,
    // search: async (address, country = {value: 'FR'}) => {
    //     // let countries = 'AT,BE,BG,HR,CY,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'

    //     let result = []
    //     let addressEncoded = encodeURI(address)
    //     await axios.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + addressEncoded + '.json?access_token=' + apiKey + '&country=' + country)
    //     .then((response) => {
    //         result = response.data.features
    //     })
    //     return result
    // }

    search: async (address, country = 'FR', types = []) => {
        return new Promise((resolve, reject) => {
            const request = {
                types: types,
                address: address,
                componentRestrictions: {
                    country: country
                }
            }
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode(request, function(results, status) {
                if (status == 'OK') {
                    resolve(results)
                } else {
                    console.warn(status)
                    resolve([]);
                }
            });
        })
    }
}
export default MapService



// WEBPACK FOOTER //
// ./src/services/map.service.js